import { Modifier as ModifierData, ModifierGroupInterface } from '../../services/exports/Interfaces';
import Modifier from './Modifier';
import { useTranslation } from 'react-i18next';
import collect from 'collect.js';
import { BasketLineItemModifier } from '../../store/types';
import BasketHelpers from '../../services/helpers/BasketHelpers';
import React, { forwardRef, useCallback } from 'react';

interface Props {
  data: ModifierGroupInterface;
  selectedModifiers: BasketLineItemModifier[];
  toggle: (modifier: ModifierData) => void;
}

const ModifierGroup = forwardRef((props: Props, ref) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:ModifierGroup' });

  const { data, selectedModifiers, toggle } = props;

  const isSelected = useCallback(
    (modifierId: number) =>
      !!collect(selectedModifiers).first(
        (item) => item.modifier_group_id === data.id && item.modifier_id === modifierId,
      ),
    [data.id, selectedModifiers],
  );

  function renderTitle() {
    const title = data.is_variant ? t('select_size') : data.name;

    return (
      <div className="mb-md bg-gray-500 lg:px-lg px-md py-xs">
        <div className="flex flex-row items-center">
          <h6 className="mr-sm">{title}</h6>
          {BasketHelpers.isModifierGroupRequired(data) && <p className="text-gray-700 text-sm">{t('required')}</p>}
        </div>
        {data.max_count > 1 && (
          <p className="text-gray-700 mt-2xs text-sm">{t('select_up_to', { maxCount: data.max_count })}</p>
        )}
      </div>
    );
  }

  return (
    <div ref={ref as React.LegacyRef<HTMLDivElement>}>
      {renderTitle()}
      <div className="lg:px-lg px-md">
        {data.modifiers.map((item: ModifierData) => (
          <div key={`modifier-group-${data.id}-modifier-${item.id}`}>
            <Modifier
              data={item}
              isSelected={isSelected(item.id)}
              isSingleSelect={data.max_count === 1}
              toggle={() => toggle(item)}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default ModifierGroup;
